import EColourPanel from "../../../interfaces/EColourPanel";
import { useTranslation } from "react-i18next";
import { resetPasswordFormRows } from "../../../formSchemas/resetPassword.form"
import ArrowForward from "@material-ui/icons/ArrowForward";
import "../../../scss/resetPassword.scss";
import DynamicForm from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import { useForgotPasswordView } from "./useForgotPasswordView";

const ForgotPasswordView = () => {
  const { sendVerificationCode , isLoading } = useForgotPasswordView();
  const { t } = useTranslation();

  return (
    <DynamicForm
      onHandleSubmit={sendVerificationCode}
      formData={{}}
      formRows={resetPasswordFormRows(t)}
      formKeyName="login"
      formButtons={{
        rightButton: {
          type: "submit",
          label: t("forms.resetPassword.submit"),
          color: EColourPanel.PRIMARY,
          fullWidth: true,
          endIcon: <ArrowForward className="arrowForward" />,
          disabled:isLoading 
        },
      }}
    />
  );
};

export default ForgotPasswordView;
